export default {
    home: 'a1.x40',
}